// hooks/usePrefactura.js
import { useState } from 'react';
import { UrlApi } from '../../../../../services/apirest';

export const usePrefactura = (pedidoId, consumidorFinal = 0) => {
  const [preFactura, setPreFactura] = useState(null);
  const [calculando, setCalculando] = useState(false);
  const [error, setError] = useState(null);

  const calcularPreFactura = async () => {
    setCalculando(true);
    setError(null);
    try {
      const response = await fetch(
        `${UrlApi}/envasado_pedidos/pagoanticipado/${pedidoId}/${consumidorFinal}`
      );
      
      if (!response.ok) {
        throw new Error("Error al calcular prefactura");
      }
      
      const data = await response.json();
      setPreFactura(data);
      
      if (data?.ErrorProcesamiento) {
        setError(data.ErrorProcesamiento);
      }
    } catch (error) {
      console.error("Error al calcular pre-factura:", error);
      setError(error.message);
    } finally {
      setCalculando(false);
    }
  };

  const totalNeto = preFactura?.factura?.ImpNeto || 0;
  const ivaCalculado = preFactura?.factura?.ImpIva || 0;
  const percepciones = preFactura?.factura?.ImpTrib || null;
  const totalFinal = preFactura?.factura?.ImpTotal || 0;

  return {
    preFactura,
    calculando,
    error,
    totalNeto,
    ivaCalculado,
    percepciones,
    totalFinal,
    calcularPreFactura
  };
};